import React from "react";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  card: {
    width: "100%",
    minWidth: 0,
    flexShrink: 0,
  },
  section: {
    height: "100%",
    padding: theme.spacing(2),
  },
  sectionTitle: {
    marginBottom: theme.spacing(1.5),
  },
  field: {
    minWidth: 0,
    overflowWrap: "anywhere",
  },
}));

function DetailField({ label, value, classes }) {
  const displayValue =
    value === null || value === undefined || String(value).trim() === ""
      ? "—"
      : String(value);

  return (
    <Grid item xs={12} sm={6} className={classes.field}>
      <Typography variant="caption" color="textSecondary">
        {label}
      </Typography>
      <Typography variant="body1" className={classes.field}>
        {displayValue}
      </Typography>
    </Grid>
  );
}

function DetailSection({ title, fields, classes }) {
  return (
    <Grid item xs={12} md={6}>
      <Paper variant="outlined" className={classes.section}>
        <Typography variant="h6" className={classes.sectionTitle}>
          {title}
        </Typography>
        <Grid container spacing={2}>
          {fields.map(([label, value]) => (
            <DetailField key={label} label={label} value={value} classes={classes} />
          ))}
        </Grid>
      </Paper>
    </Grid>
  );
}

export default function ViajeDetalleCard({ viaje }) {
  const classes = useStyles();
  const conductor = [
    viaje.conductorNombre,
    viaje.conductorPrimerApellido,
    viaje.conductorSegundoApellido,
  ]
    .filter(Boolean)
    .join(" ");

  const detailSections = [
    {
      title: "Viaje",
      fields: [
        ["Número", viaje.idVP],
        ["Tipo de servicio", viaje.servicio],
        ["Estado", viaje.estatus],
        ["Fecha de inicio", viaje.fechaInicio],
        ["Tipo de viaje", viaje.tipoViaje],
        ["Tipo de vehículo", viaje.tipoVehiculo],
        ["Centro de asistencia", viaje.direccionHospital],
        ["Lugar de recogida", viaje.lugarRecogida],
        ["Destino", viaje.destinoViaje],
        ["Pueblo del conductor", viaje.puebloTaxista],
        ["Cliente", viaje.cliente],
      ],
    },
    {
      title: "Conductor y vehículo",
      fields: [
        ["Conductor", conductor],
        ["Vehículo", viaje.vehiculo],
      ],
    },
  ];

  const patientDetails = [
    {
      title: "Primer paciente",
      name: viaje.pacientePrimero,
      nass: viaje.NASS1,
      pueblo: viaje.puebloPrimerPaciente,
      direccion: viaje.direccionPrimerPaciente,
      telefono: viaje.telfPrimerPaciente,
      telefonoAlternativo: viaje.telfPrimerPaciente2,
    },
    {
      title: "Segundo paciente",
      name: viaje.pacienteSegundo,
      nass: viaje.NASS2,
      pueblo: viaje.puebloSegundoPaciente,
      direccion: viaje.direccionSegundoPaciente,
      telefono: viaje.telfSegundoPaciente,
      telefonoAlternativo: viaje.telfSegundoPaciente2,
    },
    {
      title: "Tercer paciente",
      name: viaje.pacienteTercero,
      nass: viaje.NASS3,
      pueblo: viaje.puebloTercerPaciente,
      direccion: viaje.direccionTercerPaciente,
      telefono: viaje.telfTercerPaciente,
      telefonoAlternativo: viaje.telfTercerPaciente2,
    },
    {
      title: "Cuarto paciente",
      name: viaje.pacienteCuarto,
      nass: viaje.NASS4,
      pueblo: viaje.puebloCuartoPaciente,
      direccion: viaje.direccionCuartoPaciente,
      telefono: viaje.telfCuartoPaciente,
      telefonoAlternativo: viaje.telfCuartoPaciente2,
    },
    {
      title: "Quinto paciente",
      name: viaje.pacienteQuinto,
      nass: viaje.NASS5,
      pueblo: viaje.puebloQuintoPaciente,
      direccion: viaje.direccionQuintoPaciente,
      telefono: viaje.telfQuintoPaciente,
      telefonoAlternativo: viaje.telfQuintoPaciente2,
    },
    {
      title: "Sexto paciente",
      name: viaje.pacienteSexto,
      nass: viaje.NASS6,
      pueblo: viaje.puebloSextoPaciente,
      direccion: viaje.direccionSextoPaciente,
      telefono: viaje.telfSextoPaciente,
      telefonoAlternativo: viaje.telfSextoPaciente2,
    },
  ];

  patientDetails.forEach((patient) => {
    if (
      patient.name &&
      String(patient.name).trim() !== "" &&
      String(patient.name).trim().toUpperCase() !== "NO"
    ) {
      detailSections.push({
        title: patient.title,
        fields: [
          ["Nombre", patient.name],
          ["NASS-CIP", patient.nass],
          ["Pueblo", patient.pueblo],
          ["Dirección", patient.direccion],
          ["Teléfono", patient.telefono],
          ["Teléfono alternativo", patient.telefonoAlternativo],
        ],
      });
    }
  });

  return (
    <Card variant="outlined" className={classes.card}>
      <CardContent>
        <Typography component="h2" variant="h5" gutterBottom>
          Detalle del viaje
        </Typography>
        <Grid container spacing={2}>
          {detailSections.map((section) => (
            <DetailSection
              key={section.title}
              title={section.title}
              fields={section.fields}
              classes={classes}
            />
          ))}
        </Grid>
      </CardContent>
    </Card>
  );
}
